import { Box, Tag } from "chorda-bulma";
export default () => {
    return Box({
        css: 'is-roundless is-shadowless has-text-centered',
        content: Tag({
            text: 'Tag label',
            as: {
                css: 'has-box-shadow'
            }
        })
    });
};
